import { render, staticRenderFns } from "./AdminNotificationNew.vue?vue&type=template&id=53d5ca50&scoped=true"
import script from "./AdminNotificationNew.vue?vue&type=script&lang=js"
export * from "./AdminNotificationNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d5ca50",
  null
  
)

export default component.exports